const apiUrl = process.env.REACT_APP_API_URL;

export const GetAulaAlumnesModal = async (idAula: string | number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${idAula}/alumnes/modal`);
        if (!response.ok) return [];
        return await response.json();
    } catch (error) {
        console.error('Error fetching students:', error);
        return [];
    }
};
